import { clsx } from 'clsx';
import { twMerge } from 'tailwind-merge';

import type { ClassValue } from 'clsx';

/** Merge Tailwind classes with clsx — the standard cn() utility. */
export function cn(...inputs: ClassValue[]): string {
  return twMerge(clsx(inputs));
}
